export const FILE_TYPE_ERROR = 'Unsupported file format'
